import { Accordion as BaseUiAccordion } from '@base-ui-components/react/accordion';
import TablerIconPlus from '~icons/tabler/plus';

import type { CommonProps } from '#/ui/utils/types';
import { cn } from '#/utils/classnames';

export interface AccordionSummaryProps extends React.PropsWithChildren<CommonProps> {
  /**
   * The class name to apply to the root element.
   */
  className?: string;
}

function AccordionSummary({ children, className }: AccordionSummaryProps) {
  return (
    <BaseUiAccordion.Header className='gooey-accordion-summary-root'>
      <BaseUiAccordion.Trigger
        className={(state) =>
          cn(
            'gooey-accordion-summary',
            'group flex w-full cursor-pointer items-baseline justify-between pl-8 gap-4 py-2 text-left font-medium focus-visible:outline',
            !state.open && 'hover:bg-background-paper/80',
            className
          )
        }
      >
        {children}
        <TablerIconPlus className='gooey-accordion-icon mr-2 size-4 shrink-0 transition-all ease-out group-data-[panel-open]:scale-110 group-data-[panel-open]:rotate-45' />
      </BaseUiAccordion.Trigger>
    </BaseUiAccordion.Header>
  );
}
AccordionSummary.display = 'GooeyAccordionSummary';

export default AccordionSummary;
